import { STAGE_COLORS, PROFILE_TYPOGRAPHY } from './constants';
import type { DevelopmentalStage } from '../../types/assessment.types';
import growingIcon from '../../../assets/icons/assesment/growing.svg';
import thrivingIcon from '../../../assets/icons/assesment/thriving.svg';
import buildingIcon from '../../../assets/icons/assesment/emerging.svg';

interface DevelopmentStageBadgeProps {
  stage: DevelopmentalStage | 'notAssessed';
  muted?: boolean;
  className?: string;
}

/**
 * Inline SVG icons for each stage (from Figma design).
 * thriving = lightning bolt, growing = seedling, building = potted plant
 */
function StageIcon({ stage }: { stage: DevelopmentalStage | 'notAssessed'}) {
  switch (stage) {
    case 'thriving':
      return (
        <img
          src={thrivingIcon}
          alt="Thriving stage"
        />
      );
    case 'growing':
      return (
        <img
          src={growingIcon}
          alt="Growing stage"
        />
      );
    case 'building':
      return (
        <img
          src={buildingIcon}
          alt="Building stage"
        />
      );
  }
}

export default function DevelopmentStageBadge({ stage, muted = false, className = '' }: DevelopmentStageBadgeProps) {
  const colors = STAGE_COLORS[stage];
  const badgeBg = muted ? STAGE_COLORS.notAssessed.badgeBg : colors.badgeBg;

  return (
    <div
      className={`inline-flex items-center gap-1 px-2 py-1 ${className}`}
      style={{
        backgroundColor: badgeBg,
        borderRadius: '12px',
      }}
    >
      <StageIcon stage={stage} />
      <span
        className={`${PROFILE_TYPOGRAPHY.badgeLabel.weight} ${PROFILE_TYPOGRAPHY.badgeLabel.sizeClasses} ${PROFILE_TYPOGRAPHY.badgeLabel.extra}`}
        style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#FFFFFF',
        }}
      >
        {colors.label}
      </span>
    </div>
  );
}
